<template>
  <div>
    <v-container pa-0>
      <v-layout>
        <Head text="Author"></Head>
      </v-layout>
    </v-container>

    <v-container class="content-container">
      <v-layout row wrap>
        <v-flex xs12>
          <Heading text="Your Books"></Heading>
        </v-flex>
        <v-flex xs12></v-flex>

        <div class="section-divider"></div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Head from "./Head";
import Heading from "./Heading";

export default {
  name: "Page",
  components: { Head, Heading }
};
</script>

<style scoped>
.section-divider {
  width: 100%;
  height: 40px;
}
</style>